/* Aggiunta dei Layer in base alla zoom della mappa */  
import React from 'react'
import { useLeaflet } from "react-leaflet";
import * as WMS from "leaflet.wms";
import { connect } from "react-redux";
import axios from 'axios'

function AddLayerByZoom(props) {
    
    const service_config = props.service_config
    const {map} = useLeaflet()
    
    

    //Rimozione Layer
    const removeLayer = (nome) => {
        map.eachLayer(element => {  
          if ( element._name === nome) {
            try { 
              map.removeLayer(element)
            }
            catch(e) {
                
            }
          }
        }); 
        
    }

    function CheckLayer(layers,layerName) {
        let LayerTrovato = false
        for (const [key, value] of Object.entries(layers)) {
            
            if(value._name === layerName){LayerTrovato = true}
          } return LayerTrovato
    }
    //controllo per capire quale layer bisogna aggiungere in base al livello di zoom
     React.useEffect(()=>{ 
        
       
        if (props.userId === "0" || props.userId === 0){
            
            map.on('zoom', function(){
            
             if (props.userId === "0" || props.userId === 0){
                const zoomlevel = map.getZoom();
                
                service_config.zoomLayer.layer.map(x=>{
                    if (zoomlevel >= x.zoomValue){
                        
                        const version = service_config.serviceOnScreen.services[x.serviceIndex].version
                        const options = {
                            "version": version,
                            "format": "image/png",
                            "transparent": "true", 
                            "info_format": "application/json",
                            fetchOptions: {headers: window.tp_headers}
                        }
                        
                        
                        const source = WMS.source(
                            service_config.serviceOnScreen.services[x.serviceIndex].serviceUrl,
                            options                            
                        );

                        //NEW 
                        /*
                        var mysource = WMS.Source.extend({
                            'ajax': function(url, callback) {
                            var context = this
                            axios.get(url,{headers: {'x-api-key': window.tp_key?window.tp_key:process.env.REACT_APP_API_KEY}}).then(result => callback.call(context, result))
                            }
                        });
                        const source = new mysource(service_config.serviceOnScreen.services[x.serviceIndex].serviceUrl, options)
                        */
                        
                        if (!serviceLayer(x)?.visible){
                            let nameLayer = service_config.serviceOnScreen.services[x.serviceIndex].layersName[x.layerIndex]
                            //for(var i = 0; i< map._layers.length; i++){console.log(map._layers._name)}
                            //if(map._layers.map(x => {x._name}) === service_config.serviceOnScreen.services[x.serviceIndex].layersName[x.layerIndex]){console.log("matteo")}else{
                            
                            //if(map.hasLayer(source.getLayer(service_config.serviceOnScreen.services[x.serviceIndex].layersName[x.layerIndex]))){console.log("ciao")}else{
                            if(CheckLayer(map._layers,nameLayer)=== false){ 
                            source.getLayer(service_config.serviceOnScreen.services[x.serviceIndex].layersName[x.layerIndex]).addTo(map)}
                            
                        }
                    } else {
                
                        try {
                            if (!serviceLayer(x)?.visible){
                                removeLayer(service_config.serviceOnScreen.services[x.serviceIndex].layersName[x.layerIndex])
                            }
                        
                        } catch (error) {}
                    }
                })
                }
            })
        }
     }) 

    //Funzione per output oggetto del layer
    function serviceLayer(x){
        
        //Ricerca oggetto del servizio Layer            
        let serviceObject = props.dataList.data?.children.find(element=>{return element.name===service_config.serviceOnScreen.services[x.serviceIndex].name})
        //Ricerca Layer
        let serviceLayer = serviceObject?.children.find(element=>{return element.name === service_config.serviceOnScreen.services[x.serviceIndex].layersName[x.layerIndex]})
        
        return serviceLayer
    }
    return null;
}

const mapStateToProps = state => {
    return {
        dataList: state.dataList,

    }
  }
export default connect(mapStateToProps)(AddLayerByZoom)